// import { useState, useEffect, useRef } from 'react';
// import { getLocaleLanguage, LanguageType } from '../../../lib';
// // import styles from './style.module.scss';
// import { Input, InputRef } from 'antd';
// import classNames from 'classnames';
// import getFormatMessage from '../../../locales/get-format-message';
// // import searchIcon from '../../../assets/svg/search.svg';
// import searchDarkIcon from '../../../assets/svg/search-dark.svg';
// import { IJsonConfig, IProductsServiceItem } from '../../../model/product';
// // import { useHistory } from 'react-router-dom';
// import { getConfig } from '../../../config';
// import { AppEnvType } from '../../../model';
// import emptyIcon from '../../../assets/images/empty.png';

// interface IProps {
//   readonly lang?: LanguageType | null;
// }

// export const ProductsHoverComponent = (props: IProps) => {
//   const [configData, setConfigData] = useState<IJsonConfig | null>(null);
//   const [closeModal, setCloseModal] = useState<boolean>(false);
//   const [classifyList, setClassifyList] = useState<string[]>([]);
//   // const history = useHistory();
//   const currentStoreLanguage =
//     props.lang || getLocaleLanguage() || LanguageType.en_US;
//   const [searchValue, setSearchValue] = useState<string>('');
//   const [selectKey, setSelectKey] = useState<string>('');
//   const [showSearch, setShowSearch] = useState<boolean>(false);
//   const [searchResult, setSearchResult] = useState<IProductsServiceItem[]>([]);
//   const inputRef = useRef<InputRef>(null);
//   const selectData = configData?.serviceConfig?.[selectKey];
//   const websiteURL = getConfig()?.websiteURL;
//   const currentLanguage = props.lang || getLocaleLanguage();
//   const ingameLanguage = encodeURIComponent(
//     currentLanguage || LanguageType.en_US
//   );

//   useEffect(() => {
//     init();
//   }, [props.lang]);

//   const init = async () => {
//     let currentConfigData = configData;
//     const appConfig = getConfig();
//     const configUrl = appConfig.cdnURL
//       ? `${appConfig.cdnURL}/ingame-website/app-config/${
//           appConfig.env === AppEnvType.Production
//             ? 'prod-config'
//             : 'test-config'
//         }/${currentStoreLanguage}.json`
//       : '';
//     if (!currentConfigData) {
//       try {
//         const response = await fetch(configUrl);
//         if (!response.ok) {
//           return console.log('error');
//         }
//         const data = await response.json(); // 解析JSON格式的响应体
//         if (data) {
//           setConfigData(data);
//           currentConfigData = data;
//         }
//       } catch (error) {
//         console.error('There was a problem with your fetch operation:', error);
//       }
//     }

//     const currentClassifyList = currentConfigData?.serviceConfig
//       ? Object.keys(currentConfigData.serviceConfig)
//       : [];
//     setClassifyList(currentClassifyList);
//     let searchKey = '';
//     currentClassifyList.forEach((item) => {
//       const configDataItem = currentConfigData?.serviceConfig?.[item];
//       if (configDataItem) {
//         configDataItem.services &&
//           configDataItem.services.length !== 0 &&
//           configDataItem.services.forEach((it) => {
//             if (
//               location.pathname.includes(toLowerCaseAndRemoveSpaces(it.name))
//             ) {
//               searchKey = item;
//             }
//           });
//       }
//     });
//     setSelectKey(searchKey || currentClassifyList[0] || '');
//   };

//   const toLowerCaseAndRemoveSpaces = (str: string) => {
//     return str.toLowerCase().replace(/\s+/g, '');
//   };

//   const simpleMatch = (query: string, item: string) => {
//     return toLowerCaseAndRemoveSpaces(item).includes(
//       toLowerCaseAndRemoveSpaces(query)
//     );
//   };

//   const searchChange = (e: any) => {
//     setSearchValue(e.target.value);
//     if (e.target.value === '') {
//       setShowSearch(false);
//     } else {
//       setShowSearch(true);
//     }
//     const searchData: IProductsServiceItem[] = [];
//     classifyList.forEach((item) => {
//       const configDataItem = configData?.serviceConfig?.[item];
//       if (configDataItem) {
//         configDataItem.services &&
//           configDataItem.services.length !== 0 &&
//           configDataItem.services.forEach((it) => {
//             if (simpleMatch(e.target.value, it.name)) {
//               searchData.push(it);
//             }
//           });
//       }
//     });
//     setSearchResult(searchData);
//   };

//   const clickServiceItem = (value: string, clickAbled: boolean) => {
//     if (!clickAbled) {
//       return;
//     }
//     setCloseModal(true);
//     setTimeout(() => {
//       setCloseModal(false);
//     }, 100);
//     window.open(
//       `${websiteURL}/products/${value}?ingame_language=${ingameLanguage}`,
//       '_self'
//     );
//   };

//   const clickLeftKey = (key: string) => {
//     setSelectKey(key);
//     setShowSearch(false);
//     inputRef.current?.blur();
//   };

//   const searchFocus = () => {
//     if (searchValue !== '') {
//       setShowSearch(true);
//       const searchData: IProductsServiceItem[] = [];
//       classifyList.forEach((item) => {
//         const configDataItem = configData?.serviceConfig?.[item];
//         if (configDataItem) {
//           configDataItem.services &&
//             configDataItem.services.length !== 0 &&
//             configDataItem.services.forEach((it) => {
//               if (simpleMatch(searchValue, it.name)) {
//                 searchData.push(it);
//               }
//             });
//         }
//       });
//       setSearchResult(searchData);
//     }
//   };

//   return (
//     <div
//       className={classNames(
//         'productsHoverBox',
//         closeModal ? 'closeProductsHoverBox' : ''
//       )}
//     >
//       <div className="productsHoverContentBox">
//         <div className="productsLeftBox">
//           <Input
//             ref={inputRef}
//             className="productsLeftSearch"
//             placeholder={getFormatMessage(
//               'search_all',
//               {},
//               currentLanguage || LanguageType.en_US
//             )}
//             prefix={
//               <img src={searchDarkIcon} style={{ width: 24, height: 24 }} />
//             }
//             value={searchValue}
//             onChange={searchChange}
//             onFocus={searchFocus}
//           />
//           {classifyList.length !== 0 &&
//             classifyList.map((classifyItem) => {
//               return (
//                 <div style={{ height: '19px' }}>
//                   <span
//                     className={classNames(
//                       'productsLeftItem',
//                       selectKey === classifyItem && !showSearch
//                         ? 'productsLeftActiveItem'
//                         : ''
//                     )}
//                     onMouseEnter={() => clickLeftKey(classifyItem)}
//                     // 支持移动端点击
//                     onClick={() => clickLeftKey(classifyItem)}
//                   >
//                     {classifyItem}
//                   </span>
//                 </div>
//               );
//             })}
//         </div>
//         <div className="productRightBox">
//           {/* {selectKey &&
//             !showSearch &&
//             (selectData?.serviceTips?.firstTips ||
//               selectData?.serviceTips?.secondTips) && (
//               <div className={styles.productsRightTips}>
//                 <div className={styles.firstTips}>
//                   {selectData?.serviceTips?.firstTips || ''}
//                 </div>
//                 <div className={styles.secondTips}>
//                   {selectData?.serviceTips?.secondTips || ''}
//                 </div>
//               </div>
//             )} */}
//           {selectKey && !showSearch && (
//             <div className="productsRightService">
//               {selectData?.services &&
//                 selectData.services?.length !== 0 &&
//                 selectData.services.map((item) => {
//                   return (
//                     <div
//                       className={classNames(
//                         'serviceItem',
//                         !item.clickAbled ? 'serviceItemDefault' : ''
//                       )}
//                       onClick={() =>
//                         clickServiceItem(item.uniqueName, item.clickAbled)
//                       }
//                     >
//                       <div className="serviceItemNameBox">
//                         <span
//                           className={classNames(
//                             'serviceItemName',
//                             location.pathname.includes(`/${item.uniqueName}`)
//                               ? 'selectItem'
//                               : ''
//                           )}
//                         >
//                           {item.name}
//                         </span>
//                         {!!item.label && (
//                           <span className="serviceItemLabel">{item.label}</span>
//                         )}
//                       </div>
//                       <div className="serviceItemDesc">{item.desc}</div>
//                     </div>
//                   );
//                 })}
//             </div>
//           )}
//           {showSearch && (
//             <div className="productsRightService">
//               {searchResult.length !== 0 ? (
//                 searchResult.map((item) => {
//                   return (
//                     <div
//                       className={classNames(
//                         'serviceItem',
//                         !item.clickAbled ? 'serviceItemDefault' : ''
//                       )}
//                       onClick={() =>
//                         clickServiceItem(item.uniqueName, item.clickAbled)
//                       }
//                     >
//                       <div className="serviceItemNameBox">
//                         <span
//                           className={classNames(
//                             'serviceItemName',
//                             location.pathname.includes(`/${item.uniqueName}`)
//                               ? 'selectItem'
//                               : ''
//                           )}
//                         >
//                           {item.name}
//                         </span>
//                         {!!item.label && (
//                           <span className="serviceItemLabel">{item.label}</span>
//                         )}
//                       </div>
//                       <div className="serviceItemDesc">{item.desc}</div>
//                     </div>
//                   );
//                 })
//               ) : (
//                 <div className="emptyBox">
//                   <img src={emptyIcon} className="emptyImg" />
//                   <div className="emptyTips">
//                     {getFormatMessage(
//                       'no_search_result',
//                       {},
//                       currentLanguage || LanguageType.en_US
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };
import { useState, useEffect, useRef } from 'react';
import { getLocaleLanguage, LanguageType } from '../../../lib';
import { Input, InputRef } from 'antd';
import classNames from 'classnames';
import getFormatMessage from '../../../locales/get-format-message';
// import searchIcon from '../../../assets/svg/search.svg';
import searchDarkIcon from '../../../assets/svg/search-dark.svg';
import { IJsonConfig, IProductsServiceItem } from '../../../model/product';
// import { useHistory } from 'react-router-dom';
import { getConfig } from '../../../config';
import { AppEnvType } from '../../../model';
import emptyIcon from '../../../assets/images/empty.png';
import { isMobile } from '../../../lib/mobile';

interface IProps {
  readonly onClose: () => void;
  readonly lang?: LanguageType | null;
}
export const ProductsHoverComponent = (props: IProps) => {
  const [configData, setConfigData] = useState<IJsonConfig | null>(null);
  const [closeModal, setCloseModal] = useState<boolean>(false);
  const [classifyList, setClassifyList] = useState<string[]>([]);
  // const history = useHistory();
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const [searchValue, setSearchValue] = useState<string>('');
  const [selectKey, setSelectKey] = useState<string>('');
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [searchResult, setSearchResult] = useState<IProductsServiceItem[]>([]);
  const inputRef = useRef<InputRef>(null);
  const selectData = configData?.serviceConfig?.[selectKey];
  const websiteURL = getConfig()?.websiteURL;
  const currentLanguage = props.lang || getLocaleLanguage();
  const ingameLanguage = encodeURIComponent(
    currentLanguage || LanguageType.en_US
  );

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    let currentConfigData = configData;
    const appConfig = getConfig();
    const configUrl = appConfig.cdnURL
      ? `${appConfig.cdnURL}/ingame-website/app-config/${
          appConfig.env === AppEnvType.Production
            ? 'prod-config'
            : 'test-config'
        }/${currentStoreLanguage}.json`
      : '';
    if (!currentConfigData) {
      try {
        const response = await fetch(configUrl);
        if (!response.ok) {
          return console.log('error');
        }
        const data = await response.json(); // 解析JSON格式的响应体
        if (data) {
          setConfigData(data);
          currentConfigData = data;
        }
      } catch (error) {
        console.error('There was a problem with your fetch operation:', error);
      }
    }

    const currentClassifyList = currentConfigData?.serviceConfig
      ? Object.keys(currentConfigData.serviceConfig)
      : [];
    setClassifyList(currentClassifyList);
    let searchKey = '';
    currentClassifyList.forEach((item) => {
      const configDataItem = currentConfigData?.serviceConfig?.[item];
      if (configDataItem) {
        configDataItem.services &&
          configDataItem.services.length !== 0 &&
          configDataItem.services.forEach((it) => {
            if (
              location.pathname.includes(toLowerCaseAndRemoveSpaces(it.name))
            ) {
              searchKey = item;
            }
          });
      }
    });
    setSelectKey(searchKey || currentClassifyList[0] || '');
  };

  const toLowerCaseAndRemoveSpaces = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  const simpleMatch = (query: string, item: string) => {
    return toLowerCaseAndRemoveSpaces(item).includes(
      toLowerCaseAndRemoveSpaces(query)
    );
  };

  const searchChange = (e: any) => {
    setSearchValue(e.target.value);
    if (e.target.value === '') {
      setShowSearch(false);
    } else {
      setShowSearch(true);
    }
    const searchData: IProductsServiceItem[] = [];
    classifyList.forEach((item) => {
      const configDataItem = configData?.serviceConfig?.[item];
      if (configDataItem) {
        configDataItem.services &&
          configDataItem.services.length !== 0 &&
          configDataItem.services.forEach((it) => {
            if (simpleMatch(e.target.value, it.name)) {
              searchData.push(it);
            }
          });
      }
    });
    setSearchResult(searchData);
  };

  const clickServiceItem = (value: string, clickAbled: boolean) => {
    if (!clickAbled) {
      return;
    }
    props.onClose();
    setCloseModal(true);
    setTimeout(() => {
      setCloseModal(false);
    }, 100);
    window.open(
      `${websiteURL}/products/${value}?ingame_language=${ingameLanguage}`,
      '_self'
    );
  };

  const clickLeftKey = (key: string) => {
    setSelectKey(key);
    setShowSearch(false);
    inputRef.current?.blur();
  };

  let prevMenuSelect = '';
  const mobileClickLeftKey = (key: string) => {
    if (selectKey === key) {
      prevMenuSelect = '';
      setSelectKey('');
    } else {
      setSelectKey(key);
      setShowSearch(false);
      inputRef.current?.blur();
      prevMenuSelect = key;
    }
    console.log(prevMenuSelect);
  };

  const searchFocus = () => {
    if (searchValue !== '') {
      setShowSearch(true);
      const searchData: IProductsServiceItem[] = [];
      classifyList.forEach((item) => {
        const configDataItem = configData?.serviceConfig?.[item];
        if (configDataItem) {
          configDataItem.services &&
            configDataItem.services.length !== 0 &&
            configDataItem.services.forEach((it) => {
              if (simpleMatch(searchValue, it.name)) {
                searchData.push(it);
              }
            });
        }
      });
      setSearchResult(searchData);
    }
  };

  return (
    <div
      className={classNames(
        'productsHoverBox',
        closeModal ? 'closeProductsHoverBox' : ''
      )}
    >
      <div className="productsHoverContentBox">
        <div
          className={classNames(
            'productsLeftBox',
            showSearch && 'showSearchResult'
          )}
        >
          <Input
            ref={inputRef}
            className={'productsLeftSearch'}
            placeholder={getFormatMessage(
              'search_all',
              {},
              currentLanguage || LanguageType.en_US
            )}
            prefix={
              <img
                src={searchDarkIcon}
                style={{
                  width: isMobile() ? 48 : 20,
                  height: isMobile() ? 48 : 20,
                  marginTop: isMobile() ? '1px' : '-1px',
                }}
              />
            }
            value={searchValue}
            onChange={searchChange}
            onFocus={searchFocus}
          />
          {classifyList.length !== 0 && !showSearch && (
            <div className="productsLeftMainItem">
              {classifyList.length !== 0 &&
                classifyList.map((classifyItem) => {
                  return (
                    // <div style={{ height: isMobile() ? 'unset' : '19px' }}>
                    <div style={{ height: 'unset' }}>
                      <span
                        className={classNames(
                          'productsLeftItem',
                          selectKey === classifyItem && !showSearch
                            ? 'productsLeftActiveItem'
                            : ''
                        )}
                        onMouseEnter={() => clickLeftKey(classifyItem)}
                        // 支持移动端点击
                        onClick={() => clickLeftKey(classifyItem)}
                      >
                        {classifyItem}
                      </span>

                      <span
                        className={classNames(
                          'productsLeftItemMobile',
                          'productsLeftItem',
                          selectKey === classifyItem && !showSearch
                            ? 'productsLeftActiveItem'
                            : ''
                        )}
                        // 支持移动端点击
                        onClick={() => mobileClickLeftKey(classifyItem)}
                      >
                        {classifyItem}
                      </span>
                      {/* 移动端导航分类，pc下不显示 */}
                      {classifyItem && (
                        <div
                          className={classNames(
                            'productsRightService',
                            'productsRightServiceMobile'
                          )}
                        >
                          {configData?.serviceConfig?.[classifyItem]
                            ?.services &&
                            configData?.serviceConfig?.[classifyItem].services
                              ?.length !== 0 &&
                            configData?.serviceConfig?.[
                              classifyItem
                            ].services.map((item) => {
                              return (
                                <div
                                  className={classNames(
                                    'serviceItem',
                                    !item.clickAbled ? 'serviceItemDefault' : ''
                                  )}
                                  onClick={() =>
                                    clickServiceItem(
                                      item.uniqueName,
                                      item.clickAbled
                                    )
                                  }
                                >
                                  <div className="serviceItemNameBox">
                                    <span
                                      className={classNames(
                                        'serviceItemName',
                                        location.pathname.includes(
                                          `/${item.uniqueName}`
                                        )
                                          ? 'selectItem'
                                          : ''
                                      )}
                                    >
                                      {item.name}
                                    </span>
                                    {!!item.label && (
                                      <span className="serviceItemLabel">
                                        {item.label}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          )}
        </div>
        <div className="productRightBox">
          {/* {selectKey &&
            !showSearch &&
            (selectData?.serviceTips?.firstTips ||
              selectData?.serviceTips?.secondTips) && (
              <div className={styles.productsRightTips}>
                <div className={styles.firstTips}>
                  {selectData?.serviceTips?.firstTips || ''}
                </div>
                <div className={styles.secondTips}>
                  {selectData?.serviceTips?.secondTips || ''}
                </div>
              </div>
            )} */}
          {selectKey && !showSearch && (
            <div className="productsRightService">
              {selectData?.services &&
                selectData.services?.length !== 0 &&
                selectData.services.map((item) => {
                  return (
                    <div
                      className={classNames(
                        'serviceItem',
                        !item.clickAbled ? 'serviceItemDefault' : ''
                      )}
                      onClick={() =>
                        clickServiceItem(item.uniqueName, item.clickAbled)
                      }
                    >
                      <div className="serviceItemNameBox">
                        <span
                          className={classNames(
                            'serviceItemName',
                            location.pathname.includes(`/${item.uniqueName}`)
                              ? 'selectItem'
                              : ''
                          )}
                        >
                          {item.name}
                        </span>
                        {!!item.label && (
                          <span className="serviceItemLabel">{item.label}</span>
                        )}
                      </div>
                      <div className="serviceItemDesc">{item.desc}</div>
                    </div>
                  );
                })}
            </div>
          )}
          {showSearch && (
            <div
              className={`productsRightService 
                withSearchResult
              panel-menulist-${searchResult.length}`}
            >
              {searchResult.length !== 0 ? (
                searchResult.map((item) => {
                  return (
                    <div
                      className={classNames(
                        'serviceItem',
                        !item.clickAbled ? 'serviceItemDefault' : ''
                      )}
                      onClick={() =>
                        clickServiceItem(item.uniqueName, item.clickAbled)
                      }
                    >
                      <div className="serviceItemNameBox">
                        <span
                          className={classNames(
                            'serviceItemName',
                            location.pathname.includes(`/${item.uniqueName}`)
                              ? 'selectItem'
                              : ''
                          )}
                        >
                          {item.name}
                        </span>
                        {!!item.label && (
                          <span className="serviceItemLabel">{item.label}</span>
                        )}
                      </div>
                      <div className="serviceItemDesc">{item.desc}</div>
                    </div>
                  );
                })
              ) : (
                <div className="emptyBox">
                  <img src={emptyIcon} className="emptyImg" />
                  <div className="emptyTips">
                    {getFormatMessage(
                      'no_search_result',
                      {},
                      currentLanguage || LanguageType.en_US
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
